/**
 * @param {string} breweryId
 * @param {'beer' | 'hospitality' | 'event'} reviewType
 * @param {string} reviewId
 * @returns {string}
 */
export function buildReviewSeenDocId(breweryId, reviewType, reviewId) {
  return `${breweryId}_${reviewType}_${reviewId}`;
}

/**
 * @param {'beer' | 'hospitality' | 'event'} reviewType
 * @param {string} reviewId
 * @returns {string}
 */
export function buildReviewSeenKey(reviewType, reviewId) {
  return `${reviewType}_${reviewId}`;
}
